/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Tasks/New/TaskOverlay/Content/Content/Footer/MoveToStageAction/Content/Stages/Empty"
  
}) {
  return null
}